export default function getCurrentUrl() {
  return window ? `${window.location.protocol}//${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}` : "";
}
